import React, { useContext, useEffect } from 'react';
import { auth, parseJwt, ConfigContext, http } from './base-ui/lib.js';
import { useNavigate } from 'react-router-dom';
import Spinner from './globalComponents/spinner.js';
import SpinnerSize from './enums/spinnerSize.js';
import * as Sentry from '@sentry/react';
import { updateSentryUser } from './Sentry.js';
import { matchRoute } from './utils/matchRoute.js';
import { Role } from './types/api/AppUser.js';

export function LoginNavigationWrapper(props: { children: any }) {
	const navigate = useNavigate();
	const [loading, setLoading] = React.useState(true);
	const { config }: any = useContext(ConfigContext);

	useEffect(() => {
		const authed = auth.isAuthenticated();
		const currentUser = Sentry.getCurrentScope().getUser();

		if (!authed) {
			updateSentryUser();
			navigate(`/login?redirect=${window.location.pathname}`);
		}

		if (authed && !currentUser) {
			updateSentryUser();
		}

		if (authed) {
			checkRoutes();
		}

		setLoading(false);
	}, []);

	useEffect(() => {
		const handleLocationChange = () => {
			checkRoutes();
		};

		handleLocationChange();

		return () => {
			// Cleanup if needed (React Router v6 doesn't require explicit unlisten)
		};
	}, [navigate]);

	async function checkRoutes() {
		if (window.location.pathname === '/unauthorized') return;

		const jwt = auth.getBearerToken();
		if (!jwt) return;
		const parsedJwt = parseJwt(jwt);

		if (!parsedJwt || !parsedJwt.role) {
			console.log('[Navigation] Invalid JWT detected, redirecting to login');
			auth.logout();
			navigate(`/login?redirect=${window.location.pathname}`);
			return;
		}
		
		const role = parsedJwt.role;

		const roleDefinition: Role = await http.get(
			{},
			`${config.uri.base}/roles/name/${role}`
		);

		const isAllowed = matchRoute(
			window.location.pathname,
			roleDefinition.allowedRoutes
		);

		if (!isAllowed) {
			console.error(
				`Unauthorized access to page ${window.location.pathname} with role ${roleDefinition.roleName}`
			);
			navigate('/unauthorized');
		}
	}

	return (
		<>
			{loading && (
				<div className="mt-10 container">
					<div className="mx-auto">
						<Spinner size={SpinnerSize.MEDIUM} />
					</div>
				</div>
			)}

			{!loading && props.children}
		</>
	);
}
